export default class SafeSubmit {
  constructor(el) {
    this.el = el;

    el.addEventListener('click', e => {
      let form = el.closest('form');

      if (el.form && document.getElementById(el.form)) {
        form = document.getElementById(el.form);
      }

      if (!form) {
        return;
      }

      form.submit();

      el.disabled = true;
      el.classList.add('is-disabled');

      e.preventDefault();
    }, false);
  }
}
